import React, { useEffect, useState } from "react";
import styles from "./Clients.module.css";
import ReadMore from "../slider-component/read-more-button/ReadMore";
import SEO from "components/SEO/SEO";
import { API_BASE_URL } from "configs/AppConfig";
import { useStateManager } from "react-select";
import LoaderComponent from "../common-component/Loader/Loader";

function Clients() {
  const clientData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchClients = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}clients/getAll/public`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      setData(data?.data?.sort((a, b) => a.priority - b.priority));
      console.log("data pages", data);

      if (!response.ok) {
        // message.error(data.message);
        setLoading(false);
        throw new Error(data.message);
      }
      setLoading(false);

      // return data.data;
    } catch (err) {
      console.log("err");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  return (
    <>
      <SEO />
      {loading ? (
        <LoaderComponent />
      ) : (
        <div className={styles.outer}>
          <div className={styles.title}>
            <h1 data-aos="fade-right" data-aos-delay="200">
              Our Esteemed Clients
            </h1>
            <p data-aos="fade-right" data-aos-delay="200">
              We're proud to collaborate with businesses around the globe. Want
              to work with us?
            </p>
            <ReadMore text="Reach Us" />
          </div>
          {/* <div className={styles.meetClients}>
            <div
              data-aos="fade-down"
              data-aos-delay="200"
              className={styles.meetTitle}
            >
              <h1>Meet Our Clients</h1>
              <p>Partnering with businesses to achieve excellence together.</p>
            </div>
          </div> */}
          <div className={styles.clientsList}>
            {data?.map((client) => (
              <div className={styles.cardOuter}>
                <img src={client?.image} />
                <p>{client?.name}</p>
                <div className={styles.locationDiv}>
                  <img
                    className={styles.locationIcon}
                    src="/img/bodyshop/black-location.svg"
                  />
                  <h3>{client?.location}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default Clients;
